module.exports = require("react-dom/server");


//////////////////
// WEBPACK FOOTER
// external "react-dom/server"
// module id = 5
// module chunks = 0